import { CommonGenericModel, LastValue } from '@iot-platform/models/common';

export interface ExportSpreadsheet extends CommonGenericModel {
  assetVariableIds?: string[];
  assetVariables: { id: string; name: string; lastValue: LastValue; asset: { id: string; name: string } }[];
  contactIds: string[];
  description?: string;
  expandedContacts?: ExportSpreadsheetExpandedContact[];
  frequency: EXPORT_SPREADSHEET_FREQUENCY;
  lastRun?: string | null;
  margin: number;
  model: EXPORT_SPREADSHEET_MODEL;
  nextRun?: string;
  status: EXPORT_SPREADSHEET_STATUS;
}

export enum EXPORT_SPREADSHEET_FREQUENCY {
  EVERY_4_HOURS = 'EVERY_4_HOURS',
  EVERY_12_HOURS = 'EVERY_12_HOURS',
  EVERY_DAY = 'EVERY_DAY',
  EVERY_WEEK = 'EVERY_WEEK',
  EVERY_MONTH = 'EVERY_MONTH'
}

export enum EXPORT_SPREADSHEET_MODEL {
  ONE_ASSET_PER_TAB = 'ONE_ASSET_PER_TAB',
  SINGLE_TAB = 'SINGLE_TAB'
}

export enum EXPORT_SPREADSHEET_STATUS {
  ACTIVE = 'active',
  INACTIVE = 'inactive'
}

export interface ExportSpreadsheetExpandedContact {
  id: string;
  firstname: string;
  lastname: string;
  notificationSupports: { email: boolean };
  incorrectEmailSetting: boolean;
}
